"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncStorage = void 0;
var rxjs_1 = require("rxjs");
/**
 * Just an Observable wrapper for local- / sessionStorage
 */
var AsyncStorage = /** @class */ (function () {
    function AsyncStorage(props) {
        this.storageBackend = props.storageBackend;
    }
    AsyncStorage.prototype.getItem = function (key) {
        return (0, rxjs_1.from)([JSON.parse(this.storageBackend.getItem(key))]);
    };
    AsyncStorage.prototype.setItem = function (key, value) {
        return (0, rxjs_1.from)([this.storageBackend.setItem(key, JSON.stringify(value))]);
    };
    return AsyncStorage;
}());
exports.AsyncStorage = AsyncStorage;
